import React from "react";
import "./project.css";
import ProjectCard from "./projectCard";
import { projects } from "../../data";

export default function Project() {
  return (
    <section className="section section--soft" id="projects">
      <div className="section-inner">
        <h2 className="section-title">Projects</h2>
        <span className="section-title-accent" />
        <p className="section-subtitle">
          A selection of AI, NLP, and full-stack work — from research to shipped apps.
        </p>

        <div className="project-grid">
          {projects["projects"].map((data, id) => (
            <ProjectCard
              key={id}
              heading={data.Title}
              desc={data.Desription}
              github={data.github}
              live={data.live}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
